<!-- Created by Alex Poh. on 20/04/20.-->
<!-- Copyright © 2020 Curriculum Ltd. All rights reserved.-->

<curr-user-root>
  <router-outlet></router-outlet>
</curr-user-root>
